<template>
<div>
    <div class="d-flex flex-column-fluid">
        <!--begin::Container-->
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <div class="row">
                        <div class="col-lg-12 col-xl-12">
                            <div class="card card-custom gutter-b bg-transparent shadow-none border-0">
                                <div class="card-header align-items-center  border-bottom-dark px-0">
                                    <div class="card-title mb-0">
                                        <h3 class="card-label mb-0 font-weight-bold text-body">
                                            Customer
                                        </h3>
                                    </div>
                                    <div class="icons d-flex">
                                        <button class="btn ml-2 p-0 kt_notes_panel_toggle" data-toggle="tooltip" title="" data-placement="right" data-original-title="Check out more demos" v-if="$parent.permissions.includes('customer-manage')">
                                            <span class="bg-secondary h-30px font-size-h5 w-30px d-flex align-items-center justify-content-center  rounded-circle shadow-sm " v-on:click="
                                                        display_form = !display_form
                                                    ">
                                                <svg width="25px" height="25px" viewBox="0 0 16 16" class="bi bi-plus white" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                                    <path fill-rule="evenodd" d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"></path>
                                                </svg>
                                            </span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 ">
                            <div class="card card-custom gutter-b bg-white border-0">
                                <div class="card-body">
                                    <div class="dataTables_wrapper no-footer">

                                        <div class="cust-toolbar">
                                            <label class="mb-0 text-nowrap">Show
                                                <select v-model="limit" v-on:change="fetchcustomers()">
                                                    <option value="10">10</option>
                                                    <option value="25">25</option>
                                                    <option value="50">50</option>
                                                    <option value="100">100</option>
                                                    <option value="200">200</option>
                                                </select>
                                                entries
                                            </label>

                                            <div class="custom-control custom-switch custom-switch-info cust-switch" :class="{ on: knownOnly }">
                                                <input type="checkbox" class="custom-control-input" id="custKnownOnly" v-model="knownOnly" @change="fetchcustomers()">
                                                <label class="custom-control-label" for="custKnownOnly">
                                                    Only with contact info
                                                    <span class="d-block small text-muted">Hide anonymous visitors with no email or phone</span>
                                                </label>
                                            </div>

                                            <div class="custom-control custom-switch custom-switch-info cust-switch" :class="{ on: buyersOnly }">
                                                <input type="checkbox" class="custom-control-input" id="custBuyersOnly" v-model="buyersOnly" @change="fetchcustomers()">
                                                <label class="custom-control-label" for="custBuyersOnly">
                                                    Only buyers
                                                    <span class="d-block small text-muted">Customers with at least one paid order</span>
                                                </label>
                                            </div>

                                            <div class="d-flex align-items-center text-nowrap" style="gap:6px;" title="Date the customer account was created">
                                                <span class="text-muted small">Joined from</span>
                                                <input type="date" class="form-control form-control-sm" v-model="from" :max="to || null" @change="fetchcustomers()">
                                                <span class="text-muted small">to</span>
                                                <input type="date" class="form-control form-control-sm" v-model="to" :min="from || null" @change="fetchcustomers()">
                                            </div>

                                            <div class="d-flex align-items-center ml-xl-auto" style="gap:6px;">
                                                <input type="search" class="form-control form-control-sm" v-model="searchParameter" @input="debouncedFetch()" placeholder="Name, email or phone" style="min-width:190px;">
                                                <button v-if="searchParameter !== '' || from || to" type="button" class="btn btn-light btn-sm text-nowrap" @click="clearSearch">Clear</button>
                                                <button type="button" class="btn btn-primary btn-sm text-nowrap" :disabled="exporting" @click="exportCsv"
                                                    title="One row per person with email/phone, using the filters above">
                                                    {{ exporting ? 'Preparing...' : 'Export to Excel' }}
                                                </button>
                                            </div>
                                        </div>

                                        <div class="table-responsive">
                                        <table class="display dataTable no-footer" style="width:100%">
                                            <thead class="text-body">
                                                <tr>
                                                    <th class="cust-sort" @click="sorting('id')">ID <span>{{ arrow('id') }}</span></th>
                                                    <th class="cust-sort" @click="sorting('name')">Name <span>{{ arrow('name') }}</span></th>
                                                    <th>Email</th>
                                                    <th>Phone</th>
                                                    <th class="cust-sort text-right" @click="sorting('paid_orders')">Paid orders <span>{{ arrow('paid_orders') }}</span></th>
                                                    <th class="cust-sort text-right" @click="sorting('spent')">Total spent <span>{{ arrow('spent') }}</span></th>
                                                    <th class="cust-sort" @click="sorting('last_order')">Last order <span>{{ arrow('last_order') }}</span></th>
                                                    <th class="cust-sort" @click="sorting('created_at')">Joined <span>{{ arrow('created_at') }}</span></th>
                                                    <th>Status</th>
                                                    <th v-if="$parent.permissions.includes('customer-manage')">Action</th>
                                                </tr>
                                            </thead>
                                            <tbody class="text-dark">
                                                <tr v-if="customers.length === 0">
                                                    <td colspan="10" class="text-center">{{ loaded ? 'No customers found.' : 'Loading…' }}</td>
                                                </tr>
                                                <tr v-for="customer in customers" :key="customer.id">
                                                    <td>{{ customer.id }}</td>
                                                    <td>
                                                        <span v-if="customer.name">{{ customer.name }}</span>
                                                        <span v-else class="text-muted">Visitor #{{ customer.id }}</span>
                                                        <span v-if="customer.city" class="d-block small text-muted">{{ customer.city }}</span>
                                                    </td>
                                                    <td>
                                                        <template v-if="customer.email">
                                                            {{ customer.email }}
                                                            <span v-if="customer.renamed" class="badge badge-light ml-1"
                                                                title="Saved as a renamed duplicate (name_old_ID@...) after the same email was used again at checkout. This is the real address.">dup</span>
                                                            <span v-if="customer.from_coupon" class="badge badge-success ml-1" :title="'Coupon ' + customer.coupon">coupon</span>
                                                        </template>
                                                        <span v-else class="text-muted small">Not captured</span>
                                                    </td>
                                                    <td>
                                                        <span v-if="customer.phone">{{ customer.phone }}</span>
                                                        <span v-else class="text-muted small">—</span>
                                                    </td>
                                                    <td class="text-right">
                                                        {{ customer.paid_orders }}
                                                        <span v-if="customer.orders > customer.paid_orders" class="d-block small text-muted" title="Orders that were not paid or were cancelled">+{{ customer.orders - customer.paid_orders }} unpaid</span>
                                                    </td>
                                                    <td class="text-right">{{ customer.spent > 0 ? money(customer.spent) : '—' }}</td>
                                                    <td>{{ customer.last_order ? customer.last_order.slice(0, 10) : '—' }}</td>
                                                    <td>{{ customer.joined ? customer.joined.slice(0, 10) : '—' }}</td>
                                                    <td>
                                                        <span class="badge" :class="customer.status == '1' ? 'badge-light-success' : 'badge-light'">{{ customer.status == '1' ? 'Active' : 'Inactive' }}</span>
                                                    </td>
                                                    <td v-if="$parent.permissions.includes('customer-manage')" class="text-nowrap">
                                                        <a href="javascript:void(0)" class="click-edit mr-2" title="Edit" @click="editcustomer(customer)"><i class="fa fa-edit"></i></a>
                                                        <a href="javascript:void(0)" title="Delete" @click="deletecustomer(customer.id)"><i class="fa fa-trash"></i></a>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        </div>

                                        <div class="dataTables_paginate paging_simple_numbers">
                                            <ul class="pagination">
                                                <li class="paginate_button page-item" :class="{ disabled: !pagination.prev_page_url }">
                                                    <a class="page-link" href="#" @click.prevent="fetchcustomers(pagination.prev_page_url)">Previous</a>
                                                </li>
                                                <li class="paginate_button page-item active">
                                                    <a class="page-link" href="#">{{ pagination.current_page }} / {{ pagination.last_page }}</a>
                                                </li>
                                                <li class="paginate_button page-item" :class="{ disabled: !pagination.next_page_url }">
                                                    <a class="page-link" href="#" @click.prevent="fetchcustomers(pagination.next_page_url)">Next</a>
                                                </li>
                                            </ul>
                                            <div class="mt-2 text-muted">Total: {{ pagination.total }} customers</div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="offcanvas offcanvas-right kt-color-panel p-5 kt_notes_panel" v-if="display_form == 1" :class="display_form ? 'offcanvas-on' : ''">
        <div class="offcanvas-header d-flex align-items-center justify-content-between pb-3">
            <h4 class="font-size-h4 font-weight-bold m-0">{{ edit ? "Edit" :"Add" }} customer</h4>
            <a href="#" class="btn btn-sm btn-icon btn-light btn-hover-primary kt_notes_panel_close" v-on:click="clearForm()">
                <svg width="20px" height="20px" viewBox="0 0 16 16" class="bi bi-x" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"></path>
                </svg>
            </a>
        </div>
        <form id="myform">
            <div class="row">
                <div class="col-12">
                    <div class="form-group">
                        <label class="text-dark">First Name </label>
                        <input type="text" name="text" v-model="customerData.customer_first_name" class="form-control" />
                        <small class="form-text text-danger" v-if="errors.has('first_name')" v-text="errors.get('name')"></small>
                    </div>

                    <div class="form-group">
                        <label class="text-dark">Last Name </label>
                        <input type="text" name="text" v-model="customerData.customer_last_name" class="form-control" />
                        <small class="form-text text-danger" v-if="errors.has('last_name')" v-text="errors.get('last_name')"></small>
                    </div>

                    <div class="form-group">
                        <label class="text-dark">Email </label>
                        <input type="email" name="text" v-model="customerData.customer_email" class="form-control" />
                        <small class="form-text text-danger" v-if="errors.has('email')" v-text="errors.get('email')"></small>
                    </div>

                    <div class="form-group">
                        <label class="text-dark">Password </label>
                        <input type="text" name="text" v-model="customerData.password" class="form-control" />
                        <small class="form-text text-danger" v-if="errors.has('password')" v-text="errors.get('password')"></small>
                    </div>

                    <div class="form-group">
                        <label>Status</label>
                        <select class="js-example-basic-single js-states form-control bg-transparent" v-model='customerData.customer_status'>
                            <option v-bind:selected="customerData.customer_status == 1" value="1">Active</option>
                            <option v-bind:selected="customerData.customer_status == 0" value="0">In Active</option>
                        </select>
                        <small class="form-text text-danger" v-if="errors.has('state_id')" v-text="errors.get('status')"></small>
                    </div>

                </div>
            </div>
            <button type="button" @click="addcustomer()" class="btn btn-primary">Submit</button>
        </form>
    </div>
</div>
</template>

<script>
import ErrorHandling from "../../ErrorHandling";
export default {
    data() {
        return {
            display_form: 0,
            customerData: {
                customer_id: "",
                customer_first_name: "",
                customer_last_name: "",
                customer_email: "",
                customer_hash: "",
                customer_avatar: "",
                is_seen: "",
                customer_status: "",
                password: ""
            },
            countries: [],
            states: [],
            error_message: '',
            edit: false,
            pagination: {},
            request_method: "",
            customers: [],
            token: [],
            searchParameter: '',
            sortBy: 'id',
            sortType: 'desc',
            limit: 25,
            knownOnly: true,
            buyersOnly: false,
            from: '',
            to: '',
            exporting: false,
            loaded: false,
            timer: null,
            actions: false,
            errors: new ErrorHandling(),
            csrf: document.querySelector('meta[name="csrf-token"]').getAttribute("content")
        };
    },

    methods: {


        // Same filters as Cart Items: contact info only (default), buyers only, joined date, search.
        filterQuery() {
            let q = 'limit=' + this.limit + '&sort=' + this.sortBy + '&dir=' + this.sortType;
            if (this.searchParameter !== '') q += '&search=' + encodeURIComponent(this.searchParameter);
            if (this.knownOnly) q += '&known=1';
            if (this.buyersOnly) q += '&buyers=1';
            if (this.from) q += '&from=' + this.from;
            if (this.to) q += '&to=' + this.to;
            return q;
        },
        fetchcustomers(page_url) {
            this.$parent.loading = true;
            let url = page_url || '/api/admin/customers-list';
            // paginator links already carry the old query, so drop it before adding the current one
            url = url.replace(/[?&](limit|search|known|buyers|from|to|sort|dir)=[^&]*/g, '');
            url += (url.includes('?') ? '&' : '?') + this.filterQuery();
            axios.get(url, this.token).then(res => {
                this.customers = res.data.data;
                this.pagination = res.data.meta;
            }).catch(() => this.$toaster.error('Could not load the customers.'))
              .finally(() => { this.$parent.loading = false; this.loaded = true; });
        },
        debouncedFetch() {
            clearTimeout(this.timer);
            this.timer = setTimeout(() => this.fetchcustomers(), 350);
        },
        exportCsv() {
            // the API needs the bearer token, so a plain link would be refused
            this.exporting = true;
            axios.get('/api/admin/customers-list/export?' + this.filterQuery(), Object.assign({ responseType: 'blob' }, this.token))
                .then(res => {
                    const link = document.createElement('a');
                    link.href = URL.createObjectURL(res.data);
                    link.download = 'customers-' + new Date().toISOString().slice(0, 10) + '.csv';
                    link.click();
                    URL.revokeObjectURL(link.href);
                })
                .catch(() => this.$toaster.error('Export failed, please try again.'))
                .finally(() => { this.exporting = false; });
        },
        money(v) {
            return '$' + Number(v).toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
        },
        arrow(col) {
            if (this.sortBy !== col) return '';
            return this.sortType === 'asc' ? '▲' : '▼';
        },
        deletecustomer(id) {
            if (confirm('Are You Sure?')) {
                this.$parent.loading = true;
                axios.delete(`/api/admin/customer/${id}`, this.token)
                    .then(res => {
                        if (res.data.status == "Success") {
                            this.$toaster.success(res.data.message)
                            this.fetchcustomers();
                        }

                    })
                    .catch(err => console.log(err))
                    .finally(() => (this.$parent.loading = false));
            }
        },
        addcustomer() {
            this.$parent.loading = true;
            var url = '/api/admin/customer';
            if (this.edit === false) {
                // Add
                this.request_method = 'post'
            } else {
                // Update
                var url = '/api/admin/customer/' + this.customerData.customer_id;
                this.request_method = 'put'
            }
            axios[this.request_method](url, {
                        'first_name': this.customerData.customer_first_name,
                        'gallary_id': 1,
                        'last_name': this.customerData.customer_last_name,
                        'email': this.customerData.customer_email,
                        'status': this.customerData.customer_status,
                        'password': this.customerData.password
                    },
                    this.token)
                .then(res => {
                    if (res.data.status == "Success") {
                        this.display_form = 0;
                        this.$toaster.success(res.data.message)
                        this.fetchcustomers();
                        this.clearForm();

                    } else {
                        this.$toaster.error(res.data.message)
                    }
                })
                .catch(error => {
                    this.error_message = '';
                    this.errors = new ErrorHandling();
                    if (error.response.status == 422) {
                        if (error.response.data.status == 'Error') {
                            this.error_message = error.response.data.message;
                        } else {
                            this.errors.record(error.response.data.errors);
                        }
                    }
                }).finally(() => (this.$parent.loading = false));

        },
        editcustomer(customer) {
            this.edit = true;
            this.display_form = 1;
            this.errors = new ErrorHandling();
            this.customerData.customer_id = customer.id
            this.customerData.customer_first_name = customer.first_name
            this.customerData.customer_last_name = customer.last_name
            // the address stored on the account (may be a renamed "_old_" copy), not the cleaned one shown in the list
            this.customerData.customer_email = customer.stored_email
            this.customerData.customer_status = customer.status
            
        },
        clearForm() {
            this.edit = false;
            this.display_form = 0;
            this.customerData = {
                customer_id :"",
                customer_first_name :"",
                customer_last_name :"",
                customer_email :"",
                customer_hash :"",
                customer_avatar :"",
                is_seen :"",
                customer_status :"",
                password :""
            }
        },
        sorting(sortBy) {
            this.sortType = this.sortBy === sortBy && this.sortType === 'desc' ? 'asc' : 'desc';
            this.sortBy = sortBy;
            this.fetchcustomers();
        },
        clearSearch() {
            this.searchParameter = '';
            this.from = '';
            this.to = '';
            this.fetchcustomers();
        }
    },
    mounted() {

        var token = localStorage.getItem('token');
        this.token = {
            headers: {
                Authorization: `Bearer ${token}`
            }
        };
        this.fetchcustomers();
    }
};
</script>

<style scoped>
.cust-toolbar { display: flex; flex-wrap: wrap; align-items: center; gap: 12px 20px; margin-bottom: 16px; }
.cust-switch { border: 1px solid #e4e6ef; border-radius: 8px; padding: 6px 12px 6px 48px; transition: border-color .15s, background-color .15s; }
.cust-switch.on { border-color: #8950fc; background: #f8f5ff; }
.cust-switch .custom-control-label { cursor: pointer; font-weight: 500; line-height: 1.3; }
.cust-sort { cursor: pointer; white-space: nowrap; user-select: none; }
.cust-sort span { font-size: 10px; color: #8950fc; }
</style>
